import { NearbyStore } from '../../services/storeMapService';
import { HiOutlineOfficeBuilding } from 'react-icons/hi';
import BrandLogo from '../../components/BrandsTable/BrandLogo';
import { formatFullAddress } from '../../utils/addressUtils';
import './StoreListItem.css';

interface StoreListItemProps {
  store: NearbyStore;
  isReference?: boolean;
  isSelected?: boolean;
  onSelect?: () => void;
  onStoreClick?: (store: NearbyStore) => void;
}

function getCrimeRiskLabel(crimeRate: number): string {
  if (crimeRate >= 5000) return 'Critical';
  if (crimeRate >= 1000) return 'High';
  if (crimeRate >= 200) return 'Medium';
  if (crimeRate > 0) return 'Low';
  return 'No Data';
}

function getCrimeRiskClass(crimeRate: number): string {
  if (crimeRate >= 5000) return 'crime-risk-critical';
  if (crimeRate >= 1000) return 'crime-risk-high';
  if (crimeRate >= 200) return 'crime-risk-medium';
  if (crimeRate > 0) return 'crime-risk-low';
  return 'crime-risk-nodata';
}

function StoreListItem({ store, isReference = false, isSelected = false, onSelect, onStoreClick }: StoreListItemProps) {
  return (
    <div
      className={`store-list-item ${isReference ? 'reference-item' : ''} ${isSelected ? 'selected' : ''}`}
      onClick={() => {
        onSelect?.();
      }}
    >
      {/* Reference Site Badge */}
      {isReference && (
        <div className="reference-badge">REFERENCE SITE</div>
      )}

      {/* Store Details Section - Logo, Name, Address */}
      <div className="store-details">
        {/* Brand Logo Circle */}
        <div className={`store-icon ${isReference ? 'reference-icon' : ''}`}>
          <BrandLogo brandName={store.brand_name || ''} className="store-logo" />
        </div>

        {/* Store Info */}
        <div className="store-info">
          <div className="store-header">
            <h3 className="store-name">
              {store.brand_name || store.site || 'Unknown Store'}{(store as any).store_number ? ` ${(store as any).store_number}` : ''}
              {store.plaza_cm_customer_count && store.plaza_cm_customer_count > 0 && (
                <HiOutlineOfficeBuilding size={14} style={{ color: '#ea580c', marginLeft: '0.375rem', display: 'inline-block', verticalAlign: 'middle' }} title="Located in Shopping Complex" />
              )}
            </h3>
            {store.distance && !isReference && (
              <span className="store-distance">{store.distance.toFixed(2)} mi</span>
            )}
          </div>
          <p className="store-address">{formatFullAddress({ address: store.address, city: store.city, state: store.state, zipcode: store.zipcode })}</p>
        </div>
      </div>

      {/* Badges Section */}
      <div className="store-badges">
        {/* Status Badge - Only show if no solutions installed */}
        {!store.purchek_install_date && !store.containment_install_date && !store.cart_manager_install_date && !store.subscription_start_date && !store.paired_wheel_install_date && (
          <span className={`badge ${store.is_customer ? 'status-customer' : 'status-non-customer'}`}>
            {store.is_customer ? 'Customer' : 'Non-Customer'}
          </span>
        )}

        {/* Crime Risk Badge with Value */}
        {store.crime_rate !== null && store.crime_rate !== undefined && (
          <span className={`badge ${getCrimeRiskClass(store.crime_rate)}`}>
            Crime: {getCrimeRiskLabel(store.crime_rate)}
          </span>
        )}

        {/* Solutions Installed */}
        {store.purchek_install_date && (
          <span className="badge solution-badge">Purchek</span>
        )}
        {store.containment_install_date && (
          <span className="badge solution-badge">Cart Containment</span>
        )}
        {store.cart_manager_install_date && (
          <span className="badge solution-badge">Cart Manager</span>
        )}
        {store.subscription_start_date && (
          <span className="badge solution-badge">Subscription</span>
        )}
        {store.paired_wheel_install_date && (
          <span className="badge solution-badge">Paired Wheel</span>
        )}
      </div>
    </div>
  );
}

export default StoreListItem;
